// extracted by mini-css-extract-plugin
export default {"copyright":"copyright_copyright__oh6jf","copyrightContent":"copyright_copyrightContent__nvFuA"};